module.exports = __webpack_public_path__ + "media/images/footer/grand-est-2f1ce26f7845c1c37cb0f893fb8b6cbc.png";